import React from "react";

function HeaderContainer({ children }) {
  return <div className='sticky-header-container'>{children}</div>;
}

export default HeaderContainer;
